import {
  BrowserRouter as Router,
  Redirect
} from 'react-router-dom';
import Routes from '../Routes/Routes';
import Login from '../../containers/Login/Login';
import LoginToImpersonateClient from '../../containers/Login/LoginToImpersonateClient';
import ResetPassword from '../../containers/ResetPassword/ResetPassword';

export default function NonAuthenticatedApp() {
  
  const routes = [
    {
      id: 1,
      path: '/resetpassword',
      exact: true,
      component: <ResetPassword />
    },
    {
      id: 2,
      path: '/impersonateClient',
      exact: true,
      component: 
          <LoginToImpersonateClient />
    },
    {
      id: 3,
      path: '/',
      exact: false,
      component: (
        <>
          <Redirect to="/" />
          <Login/>
        </>
      )
    },
    
  ];

  return (
    <Router>
      <Routes routes={routes}/>
    </Router>
  );
}
